import { RoleViewModel, WalkAndPunchApiClient } from 'src/proxy/api/walkandpunch-api.proxy';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class RoleStoreService {
  _roles$ = new BehaviorSubject<RoleViewModel[]>(null);

  constructor(private authCoreService: WalkAndPunchApiClient) {}

  loadRoles() {
    return this.authCoreService.v1AuthCoreGetRolesGET(false);
  }

  get roles() {
    return this._roles$.value;
  }

  set roles(data: RoleViewModel[]) {
    this._roles$.next(data);
  }

  get roles$() {
    return this._roles$;
  }
}
